import { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  isV2Path,
  toV2EquivalentPath,
} from "../../universal/v2Routes";

export default function useUiDesignLaneRedirect(user, isAuthenticated, autoLoginInProgress) {
  const history = useHistory();
  const location = useLocation();
  const lastRedirectRef = useRef(null);

  useEffect(() => {
    if (!isAuthenticated || autoLoginInProgress || !user?.userId) {
      return;
    }

    const preference = user.uiDesignPreference;
    const pathname = location.pathname;
    const redirectKey = `${preference}:${pathname}`;

    if (lastRedirectRef.current === redirectKey) {
      return;
    }

    if (
      preference === "v2" &&
      user.uiV2PromptState !== "pending" &&
      !isV2Path(pathname)
    ) {
      const targetPath = toV2EquivalentPath(pathname);
      if (targetPath && targetPath !== pathname) {
        lastRedirectRef.current = `${preference}:${targetPath}`;
        history.replace(targetPath);
      }
    }
  }, [
    autoLoginInProgress,
    history,
    isAuthenticated,
    location.pathname,
    user?.uiDesignPreference,
    user?.uiV2PromptState,
    user?.userId,
  ]);
}
